import clsx from 'clsx';
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import parse from 'html-react-parser';

import { useAppConfigContext } from '../../hooks/useAppConfigContext';
import styles from './Project.module.css';
import { getProject } from '../../utils/api';
import { BASE_URL } from '../../utils/constants';
import { Images } from './Project.types';

export const Project = ({ paddingCalc }: any) => {
  const params = useParams();
  const { projects } = useAppConfigContext();
  const location = useLocation();

  const [content, setProjectContent] = useState<object[]>([]);
  const [images, setImages] = useState<Images>([]);

  const projectInfo = projects.find(
    (project) => project.id === params.projectId,
  );

  const htmlText = useMemo(
    () => projectInfo && parse(projectInfo.designer.description),
    [projectInfo?.designer.description],
  );

  const getImages = () => {
    if (params.projectId) {
      getProject(params.projectId)
        .then((data) => setProjectContent(data))
        .catch((err) => console.log('err', err));
    }
  };

  useEffect(() => {
    getImages();
  }, []);

  useEffect(() => {
    if (projectInfo) {
      location.state = { navName: projectInfo.name };
    }
  }, [projectInfo]);

  useEffect(() => {
    if (content?.length) {
      let number = 1;

      const list = content.reduce((res: Images, item) => {
        // @ts-ignore
        const key = item?.Key.split('/')[2]?.split('.')[0];

        if (number > 6) {
          number = 1;
        }

        if (key) {
          res.push({
            id: key,
            number: Number(number),
            // @ts-ignore
            imageUrl: `${BASE_URL}/${item.Key}`,
          });
          number += 1;
        }
        return res;
      }, []);

      const sorted = list.sort((a, b) => +a.id - +b.id);
      setImages(sorted);
    }
  }, [content]);

  return (
    <section style={paddingCalc}>
      <div className={styles.gridContainer}>
        {images?.map((item) => {
          return (
            <div
              key={item.id}
              className={clsx(
                'overflow-hidden',
                item.number === 4 &&
                  'col-start-1 col-end-7 sm:col-start-1 sm:col-end-4', // 1/2
                item.number === 5 &&
                  'col-start-1 col-end-7 sm:col-start-4 sm:col-end-7', // 1/2
                item.number === 1 &&
                  'col-start-1 col-end-7 md:col-start-1 md:col-end-3', // 1/3
                item.number === 2 &&
                  'col-start-1 col-end-7 sm:col-start-1 sm:col-end-4 md:col-start-3 md:col-end-5', // 1/3
                item.number === 3 &&
                  'col-start-1 col-end-7 sm:col-start-4 sm:col-end-7 md:col-start-5 md:col-end-7', // 1/3
                item.number === 6 && 'col-start-1 col-end-7', // 1
              )}
            >
              <img
                className={styles.image}
                src={item.imageUrl}
                alt={item.id}
                loading="lazy"
              />
            </div>
          );
        })}
      </div>
      {projectInfo && (
        <div className={styles.heroContainer}>
          <div className={styles.designerInfo}>
            <img
              className={clsx(styles.image, styles.heroImage)}
              src={projectInfo.designer.photo}
              alt="designer"
            />
            <h3>Дизайнер {projectInfo.designer.name}</h3>
            <p>{projectInfo.designer.contact}</p>
          </div>

          <div className={styles.textContainer}>
            <div className={styles.titleBox}>
              <h2 className={styles.title}>{projectInfo.name}</h2>
              <p className={styles.subtitle}>
                {`${projectInfo.year} ${projectInfo.location} ${projectInfo.area}m`}
                <sup>2</sup>
              </p>
            </div>
            <article className={styles.description}>{htmlText}</article>
          </div>
        </div>
      )}
    </section>
  );
};
